import React from 'react';
import { motion } from 'framer-motion';
import { CART_LINK } from './constants';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  scrollTo?: string;
}
export function CTAButton({
  children,
  className = '',
  onClick,
  scrollTo
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (scrollTo) {
      e.preventDefault();
      const el = document.getElementById(scrollTo);
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
    if (onClick) onClick(e);
  };
  return <motion.a href={scrollTo ? `#${scrollTo}` : CART_LINK} onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${`inline-flex items-center justify-center bg-bordeaux text-white font-inter font-bold py-5 px-8 rounded-none uppercase tracking-widest transition-colors hover:bg-bordeaux-hover shadow-2xl text-center ${className}`} text-[#FF0000] bg-[#FFFFFF]`} data-id="element-62">
      {children}
    </motion.a>;
}